module.exports = __webpack_public_path__ + "img/returnUnitCompressed.a17fd04d.gif";